import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.block-team-carousel-slider .swiper'
);

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const settings = {
			loop: false,
			grabCursor: true,
			spaceBetween: 32,
			modules: [Navigation],
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
			breakpoints: {
				0: {
					slidesPerView: 1.09,
				},
				576: {
					slidesPerView: 4,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
